// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"83bdb8d6","492":"d36bded2"}[chunkId] + ".chunk.js";
};